import { render, staticRenderFns } from "./IconFacebook.vue?vue&type=template&id=238a9cda&scoped=true&"
import script from "./IconFacebook.vue?vue&type=script&lang=js&"
export * from "./IconFacebook.vue?vue&type=script&lang=js&"
import style0 from "./IconFacebook.vue?vue&type=style&index=0&id=238a9cda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238a9cda",
  null
  
)

export default component.exports